import { motion } from 'framer-motion'

import { ButtonRoundSm } from '@apps-common/components/elements/button/ButtonRoundSm'
import { commonIcons } from '@apps-common/config/icons'
import { GRID_CARD_VARIANTS } from '@apps-common/config/motion-variants'
import { INonAllocatedSimModel } from '@apps-common/types/management/non-allocated-sim'
import { ISimApnModel } from '@apps-common/types/management/sim-apn'

interface IProps {
  simApns: ISimApnModel[]
  sim: INonAllocatedSimModel
  callback: (sim: INonAllocatedSimModel) => void
}
export const NonAllocatedSimListCardSm = ({ simApns, sim, callback }: IProps) => {
  const { simApnId, simNo, mobileNo, ip, userId } = sim

  const apn = simApns?.find((sa) => sa.simApnId === simApnId)

  return (
    <motion.div
      variants={GRID_CARD_VARIANTS}
      className='card w-full p-4 bg-surface text-text border border-border hover:cursor-pointer text-[0.875em]'
      onClick={() => callback(sim)}
    >
      <div className='flex items-center justify-between w-full'>
        <div className='jost-medium text text-text'>{simNo}</div>
      </div>
      <div className='flex items-end justify-between'>
        <div>
          <p className='jost-light text-md text-ellipsis overflow-hidden'>{mobileNo}</p>
          <p className='jost-light text-md text-ellipsis overflow-hidden'>{ip}</p>
          <p className='jost-light text-md text-ellipsis overflow-hidden'>{apn?.simApnName}</p>
        </div>
        <ButtonRoundSm type='button' className='bg-brand text-on-brand'>
          <commonIcons.arrowAngled />
        </ButtonRoundSm>
      </div>
    </motion.div>
  )
}
